module.exports = __webpack_public_path__ + "img/2-lonely-bear_v8e.22e68d04.png";